import { Text } from '@dixa/lib-shared-habla';
import {
  SearchFilterConditionCustomAttribute,
  SearchFilterConditionCustomAttributeSelect,
  SearchFilterConditionCustomAttributeText,
} from 'lib-search-types';
import { memo } from 'react';

import { useFilterConditionCustomAttribute } from '../../../../utils/useFilterConditionCustomAttribute';
import { ConditionFieldProps } from '../../conditionField';
import { ConditionFieldCustomAttributeText } from '../select/conditionFieldSelect';

import { ConditionFieldCustomAttributeSelect } from './components/select/conditionFieldCustomAttributeSelect';

export const ConditionFieldCustomAttribute = memo(
  function ConditionFieldCustomAttribute(
    props: ConditionFieldProps<
      | SearchFilterConditionCustomAttribute<'conversation_custom_attribute'>
      | SearchFilterConditionCustomAttribute<'contact_custom_attribute'>
    >,
  ): JSX.Element {
    const customAttribute = useFilterConditionCustomAttribute(props.condition);

    if (!customAttribute) {
      return <Text.Input variant="error">Something went wrong.</Text.Input>;
    }

    switch (customAttribute.type) {
      case 'select':
        return (
          <ConditionFieldCustomAttributeSelect
            attribute={customAttribute}
            {...(props as ConditionFieldProps<
              | SearchFilterConditionCustomAttributeSelect<'conversation_custom_attribute'>
              | SearchFilterConditionCustomAttributeSelect<'contact_custom_attribute'>
            >)}
          />
        );
      case 'text':
        return (
          <ConditionFieldCustomAttributeText
            {...(props as ConditionFieldProps<
              | SearchFilterConditionCustomAttributeText<'conversation_custom_attribute'>
              | SearchFilterConditionCustomAttributeText<'contact_custom_attribute'>
            >)}
          />
        );
    }
  },
);
